import { useRef } from 'react';

export function useOnce(cb: () => void) {
  const hasRun = useRef(false);
  if (!hasRun.current) {
    cb();
    hasRun.current = true;
  }
}
